export const jwtPayload = (accessToken: string) => {
  if (!accessToken || !accessToken.length) {
    return {};
  }
  return JSON.parse(atob(accessToken.split('.')[1]));
};
